import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import adminAuthService from '../services/authService';

const AdminAuthContext = createContext(undefined);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    setLoading(true);
    try {
      if (adminAuthService.isAuthenticated()) {
        const isValid = await adminAuthService.verifyToken();
        if (isValid) {
          setUser(adminAuthService.getCurrentUser());
        } else {
          setUser(null);
        }
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error('Auth check error:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    console.log('🔵 Context: login called');
    try {
      const response = await adminAuthService.login(email, password);
      console.log('🟢 Context: login response', response);
      if (response.success && response.token) {
        setUser(response.user);
        console.log('🟢 Context: user set', response.user);
      }
      return response;
    } catch (error) {
      console.log('🔴 Context: login error', error);
      throw error;
    }
  };

  const verify2FA = async (tempToken, code) => {
    const response = await adminAuthService.verify2FA(tempToken, code);
    if (response.success && response.token) {
      setUser(response.user);
    }
    return response;
  };

  const logout = useCallback(async () => {
    await adminAuthService.logout();
    setUser(null);
  }, []);

  const value = {
    user,
    loading,
    login,
    verify2FA,
    logout,
    isAuthenticated: !!user,
    checkAuth,
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (context === undefined) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
};

export default AdminAuthContext;
